module.exports = __webpack_public_path__ + "img/more_shutdown.a5260606.png";